"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FinProSimpleSearchCard = FinProSimpleSearchCard;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CTAButton = _interopRequireDefault(require("../../components/CTAButton"));
var _FinProOrAgencyDropdown = _interopRequireDefault(require("./FinProOrAgencyDropdown"));
var _NameOrZipCodeInput = _interopRequireDefault(require("./NameOrZipCodeInput"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _api = require("@react-google-maps/api");
var _defaultSearchState = _interopRequireDefault(require("./defaultSearchState"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var googleMapUiKey = '';
if (typeof window !== 'undefined') {
  googleMapUiKey = window.GOOGLE_MAPS_API_KEY;
}
var LIBRARIES_ARRAY = ['places', 'maps', 'marker', 'core'];
var MAP_ID_ARRAY = ['a1338bda8d063b0a'];
function FinProSimpleSearch(props) {
  var [searchState, setSearchState] = (0, _react.useState)({
    finProOrAgencySelection: 'Financial Professional',
    nameOrZipCodeInputSelection: '',
    searchByName: false
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container"
  }, /*#__PURE__*/_react.default.createElement(FinProSimpleSearchCard, {
    className: "mm-desktop-only",
    searchState: searchState,
    setSearchState: setSearchState,
    onSearch: props.onSearch,
    sourcePage: "home"
  }), /*#__PURE__*/_react.default.createElement(FinProSimpleSearchCard, {
    className: "mm-tablet-mobile-only",
    searchState: searchState,
    setSearchState: setSearchState,
    onSearch: props.onSearch,
    sourcePage: "home"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-text-center"
  }, /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
    buttonType: 'inline',
    label: 'Select an agency by state',
    href: '/us',
    linkAlt: 'Search By State'
  })));
}
function FinProSimpleSearchCard(_ref) {
  var {
    className,
    searchState,
    setSearchState,
    onSearch,
    sourcePage,
    shouldNotTriggerAutocomplete,
    setApiData,
    setIsLoading,
    setGoogleApiIsLoaded
  } = _ref;
  var finProOrAgencySelectionArray = ['Financial Professional', 'Agency'];
  var isDesktop = className === 'mm-desktop-only';
  var autocompleteService = (0, _react.useRef)(null);
  var placesService = (0, _react.useRef)(null);
  // Keeps track of if the search term is programtically set, we will use this to cancel autocomplete
  var isProgrammaticUpdate = (0, _react.useRef)(false);
  // Keeps track of whether a submission has happened and cancels async autocomplete in race condition
  var cancelAutocompleteRef = (0, _react.useRef)(false);
  var {
    isLoaded,
    loadError
  } = (0, _api.useJsApiLoader)({
    googleMapsApiKey: googleMapUiKey,
    libraries: LIBRARIES_ARRAY,
    mapIds: MAP_ID_ARRAY,
    version: 'beta'
  });
  (0, _react.useEffect)(() => {
    if (isLoaded && !autocompleteService.current) {
      // If prop exists then call the function, this will avoid map race condition issues in visgl
      if (setGoogleApiIsLoaded) setGoogleApiIsLoaded(true);
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
      placesService.current = new window.google.maps.places.PlacesService(document.createElement('div'));
    }
    if (loadError) {
      console.error(loadError);
    }
  }, [isLoaded]);
  (0, _react.useEffect)(() => {
    if (searchState.setFromHomePage) {
      if (!searchState.searchByName && searchState.nameOrZipCodeInputSelection === '') {
        localStorage.setItem('searchData', JSON.stringify(_objectSpread(_objectSpread({}, _defaultSearchState.default), {}, {
          finProOrAgencySelection: searchState.finProOrAgencySelection
        })));
      } else {
        localStorage.setItem('searchData', JSON.stringify(searchState));
      }
    }
    setSearchState(prevState => {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        setFromHomePage: false
      });
    });
  }, [searchState.setFromHomePage]);

  /**
   * Handles the final search based on the input value.
   * Uses the autocomplete service to get place predictions and retrieves details for the first result.
   * Updates the search state with the selected place information and triggers the search.
   * If no predictions are found, resets the search state to default.
   */
  var handleFinalSearch = () => {
    if (searchState.searchByName) {
      // in search by name scenario we simply want to use what the user has typed in
      // explicitly want to use double quotes here to match design
      setSearchState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          lastSearchedTerm: searchState.nameOrZipCodeInputSelection === '' ? "" : searchState.nameOrZipCodeInputSelection,
          lastSearchedWasByName: true,
          setFromHomePage: sourcePage === 'home'
        });
      });
      if (sourcePage !== 'home') onSearch();
    } else {
      // handleFinalSearch in search by location scenario
      // Get autocomplete predictions and details for the first result, else use default search settings
      if (autocompleteService.current && searchState.nameOrZipCodeInputSelection !== '') {
        autocompleteService.current.getPlacePredictions({
          input: searchState.nameOrZipCodeInputSelection,
          types: ['locality', 'postal_code'],
          componentRestrictions: {
            country: ['us', 'pr']
          }
        }, (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions.length > 0) {
            var firstResult = predictions[0];
            // get the lat and lng of the first result
            placesService.current.getDetails({
              placeId: firstResult.place_id
            }, (place, status) => {
              if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                var {
                  lat,
                  lng
                } = place.geometry.location;
                // Set lat lng from the first result and reset all filter related fields
                setSearchState(prevState => {
                  return _objectSpread(_objectSpread({}, prevState), {}, {
                    lastSearchedTerm: firstResult.description,
                    lastSearchedWasByName: false,
                    nameOrZipCodeInputPlaceId: firstResult.place_id,
                    lat: lat(),
                    lng: lng(),
                    distanceMiles: 5,
                    distanceFilterSelectionIndex: 1,
                    languageSelection: [],
                    specialtySelection: [],
                    setFromHomePage: sourcePage === 'home'
                  });
                });
                if (sourcePage !== 'home') onSearch();
              }
            });
          } else {
            // if autocomplete service finds no results, and the search input is empty, reset the search state to default
            if (searchState.nameOrZipCodeInputSelection === '') {
              setSearchState(prevState => {
                return _objectSpread(_objectSpread(_objectSpread({}, prevState), _defaultSearchState.default), {}, {
                  finProOrAgencySelection: prevState.finProOrAgencySelection,
                  searchByName: prevState.searchByName,
                  setFromHomePage: sourcePage === 'home'
                });
              });
              isProgrammaticUpdate.current = true;
              if (sourcePage !== 'home') onSearch();
            } else {
              // Use the values the user has typed in, but do not search as we will not have a lat/lng to search based off
              // Update data for last search (lastSearchedTerm,lastSearchedWasByName) & set the apiData to an empty array to clear the results
              setSearchState(prevState => {
                return _objectSpread(_objectSpread({}, prevState), {}, {
                  lastSearchedTerm: searchState.nameOrZipCodeInputSelection,
                  lastSearchedWasByName: false,
                  setFromHomePage: sourcePage === 'home',
                  lat: '',
                  lng: ''
                });
              });
              if (sourcePage !== 'home') onSearch();
            }
          }
        });
      } else {
        // if autocomplete service is not up and running, or user did blank search
        // reset the search state to default
        setSearchState(prevState => {
          return _objectSpread(_objectSpread(_objectSpread({}, prevState), _defaultSearchState.default), {}, {
            finProOrAgencySelection: prevState.finProOrAgencySelection,
            searchByname: prevState.searchByName,
            setFromHomePage: sourcePage === 'home',
            lastSearchedTerm: 'New York, NY 10001',
            lastSearchedWasByName: false
          });
        });
        isProgrammaticUpdate.current = true;
        if (sourcePage !== 'home') onSearch();
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      if (sourcePage === 'home') {
        handleFinalSearch();
        window.location.href = '/search';
      } else {
        cancelAutocompleteRef.current = true;
        handleFinalSearch();
      }
    },
    className: "finpro-search ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(isDesktop ? 'mm-text-center' : undefined)
  }, /*#__PURE__*/_react.default.createElement(_FinProOrAgencyDropdown.default, {
    isDesktop: isDesktop,
    searchState: searchState,
    setSearchState: setSearchState,
    finProOrAgencySelectionArray: finProOrAgencySelectionArray,
    sourcePage: sourcePage,
    onSearch: onSearch,
    handleFinalSearch: handleFinalSearch,
    setIsLoading: setIsLoading
  }), /*#__PURE__*/_react.default.createElement(_NameOrZipCodeInput.default, {
    isDesktop: isDesktop,
    searchState: searchState,
    setSearchState: setSearchState,
    searchByName: searchState.searchByName,
    onSearch: onSearch,
    shouldNotTriggerAutocomplete: shouldNotTriggerAutocomplete,
    sourcePage: sourcePage,
    autocompleteService: autocompleteService,
    placesService: placesService,
    isProgrammaticUpdate: isProgrammaticUpdate,
    cancelAutocompleteRef: cancelAutocompleteRef
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(isDesktop ? 'add-margin-left' : '')
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: "primary",
    type: "submit"
  }, "Search")), /*#__PURE__*/_react.default.createElement("span", {
    className: "copy-lg add-margin-left add-margin-right"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "|")), /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
    buttonType: 'inline',
    label: searchState.searchByName ? 'Search by Location' : 'Search by Name',
    onClick: () => setSearchState(prevState => {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        searchByName: !searchState.searchByName,
        nameOrZipCodeInputSelection: ''
      });
    }),
    href: "",
    linkAlt: ""
  })))));
}
var _default = exports.default = FinProSimpleSearch;